import { Collapse, Empty, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { HttpStatusCodes } from "./api";
import { getPublications, PublicationsQuery } from "./api/publications";
import { Publication } from "./api/publications.model";
import { PublicationFilters } from "./Filters/PublicationFilters";
import { PublicationCard } from "./PublicationCard/PublicationCard";
import "./App.less";

export const App: React.FC<{}> = (props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [publications, setPublications] = useState<Publication[]>([]);
  const [query, setQuery] = useState<PublicationsQuery>({});
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      setError(false);
      setLoading(true);
      const [responseCode, publications] = await getPublications(query);
      setLoading(false);

      if (responseCode === HttpStatusCodes.OK && publications !== null) {
        setPublications(publications.data);
      } else {
        setError(true);
      }
    };

    fetchData();
  }, [query]);

  // Render page content
  let content;
  if (error) {
    content = <Empty description="Could not get publications from server!" />;
  } else if (publications.length === 0) {
    content = <Empty description="No publications match the search criteria" />;
  } else {
    content = publications.map((p) => (
      <PublicationCard publication={p} key={p.recordId} />
    ));
  }

  return (
    <div className="publications-page">
      <Collapse>
        <Collapse.Panel key="filters" header="Filters">
          <PublicationFilters
            publications={publications}
            onChange={(query) => setQuery(query)}
          />
        </Collapse.Panel>
      </Collapse>

      <div className="publications-page-content">
        <Spin spinning={loading}>{content}</Spin>
      </div>

      <div className="publications-footer">
        Powered by Zenodo.{" "}
        <a href="https://zenodo.org/communities/noa-react">
          Visit ReACT on Zenodo.
        </a>
      </div>
    </div>
  );
};

export default App;
